export default "__VITE_ASSET__BoSl9nYz__"